import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import serverService from 'api/services/server.service';

import { APIKeys } from 'common/enum/api-keys.enum';

export const useSystemSettings = ({
  token,
  tenantName,
  isRootLogin,
}: {
  token: string;
  tenantName: string;
  isRootLogin: boolean;
}) => {
  const { data, refetch, isFetching } = useQuery<Record<string, any>>({
    placeholderData: {},
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: [APIKeys.SYSTEM_SETTINGS],
  });

  const fetchData = async (): Promise<Record<string, any>> => {
    try {
      const { content } = await serverService.getSettings({
        token,
        ...(isRootLogin && { tenantName }),
      });
      const { login_providers, ...props } = content;

      return {
        ...props,
        loginProviders: login_providers,
      };
    } catch (error: any) {
      toastError('Failed to fetch system settings', error);

      throw error;
    }
  };

  return {
    data,
    fetch: refetch,
    isLoading: isFetching,
  };
};
